<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="room">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            体检项目
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit" @click.native="handleEdit">编辑</el-button>
                    <el-button type="danger"    :disabled="disabledSetUp" @click.native="handleSetUp">批量设置</el-button>
                    <div style="float:right">
                        <el-input  placeholder="请输入房间号" v-model="title" clearable style="margin:0 10px;width:200px"></el-input>
                        <el-select v-model="tagSelect"  clearable placeholder="选择是否是当前体检项目" style="margin:0 10px;" >
                            <el-option
                                    v-for="item in tagSelectValue"
                                    :key="item[0]"
                                    :label="item[1]"
                                    :value="item[0]">
                            </el-option>
                        </el-select>
                        <el-select v-model="status" placeholder="选择体检项目状态" style="margin:0 10px;" >
                            <el-option
                                    v-for="item in statusValue"
                                    :key="item[0]"
                                    :label="item[1]"
                                    :value="item[0]">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table
                        ref="multipleTable"
                        :data="tableData"
                        v-loading="loading"
                        tooltip-effect="dark"
                        style="width: 100%"
                         :height="th" border
                         current-row-key='testItemCode'
                         highlight-current-row @row-click='rowClick'
                        @selection-change="handleSelectionChange">
                         <el-table-column
                            type="selection"
                            width="55">
                            </el-table-column>
                    <!-- <el-table :data="tableData" :height="th" border style="width: 100%;" highlight-current-row @row-click='rowClick'> -->

                        <el-table-column prop="inspectionItemName" label="科室检查项目"></el-table-column>

                        <el-table-column prop="tagSelect" :formatter="getTagSelect" label="是否是当前体检项目"></el-table-column>

                        <el-table-column prop="status" :formatter="getStatus" label="状态"></el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </template>
            </div>

        </div>
        <Add ref="myAdd" v-show="showModalAdd" v-bind:inspectionItemList="inspectionItemList" v-on:closeAdd="showModalAdd=false" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:inspectionItemList="inspectionItemList" v-on:closeEdit="showModalEdit=false" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                disabledAdd:true,
                disabledSetUp:true,
                menuButtonList:null,
                disabledEdit:false,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                title:'',
                selectInfo:'',
                inspectionItemList:[],
                tagSelect:'',
                status:-1,
                statusValue:[[-1,'全部状态'],[1,'正常'],[2,'废弃']],
                tagSelectValue:[[1,'是'],[2,'否']],
                multipleSelection:[]
            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.init();
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
             getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            init(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InspectionItem/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.inspectionItemList = response.data.data;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection =val;
            },
            timefilter(row,index,column){
                return timefilters(column)
            },
            handleSetUp(){
                if(this.multipleSelection.length==0){
                    this.$message.error('请选择所需体检项目')
                    return
                }
                 this.$confirm('是否将所选体检项目设为当前体检项目?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var arr=this.multipleSelection
                    var testItemCodeArr=[]
                    arr.forEach(element => {
                        testItemCodeArr.push(element.testItemCode)
                    });
                    this.$axios({
                        method: 'post',
                        url: this.$institutionUrl+"TestItem/Check",
                        data: {
                            timeStr:timeStr,
                            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                            staffCode: getStaffCode(),
                            testItemCodeArr:testItemCodeArr
                        }
                    }).then( (response)=> {
                        if(response.data.error == 0){
                            this.$message.success('设置成功')
                            this.getList()
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消设置'
                    });          
                });
                
            },
            handleEdit() {
                this.$refs.myEdit.init(this.selectInfo);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.$refs.myAdd.init();
                this.showModalAdd = !this.showModalAdd;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            getList(){
                this.loading=true;
                var tagSelect=''
                this.tagSelect?tagSelect=this.tagSelect:tagSelect=-1
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"TestItem/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        inspectionItemName:this.inspectionItemName,
                        status:this.status,
                        tagSelect:tagSelect,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading=false;
                    this.disabledSetUp=true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        this.disabledEdit=true
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getTagSelect(row,index,column){
                const tagSelectValue=this.tagSelectValue
                for(var i in tagSelectValue){
                    if(tagSelectValue[i][0]==column){
                        return tagSelectValue[i][1]
                    }
                } 
            },
            getStatus(row,index,column){
                const statusValue=this.statusValue
                for(var i in statusValue){
                    if(statusValue[i][0]==column){
                        return statusValue[i][1]
                    }
                } 
            },
             rowClick(row){
                this.disabledEdit=true
                this.selectInfo=row
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit =false;
                }
                if(this.menuButtonList.indexOf("批量设置")!=-1){
                    this.disabledSetUp =false;
                }
            }
        }
    }
</script>

<style lang='scss' scoped>
    .room /deep/ .el-table__body tr.current-row>td {
        background: rgb(121, 187, 255);
        color:#fff;
    }
</style>
